// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"PP-z","upvoteIcon":"QP-z","downvoteIcon":"RP-z","feedbackIcon":"SP-z"};